<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-download', fontSet: 'fad'}"
	[headerText]="T.TOOLTIP_EXPORT_EVENT | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<sim-scenario-archive-exports-panel [panelOpen]="true" [scenarioEventId]="data.eventId" [scenarioEventIdList]="data.eventIdList" />
	</ng-container>

	<ng-container actions />
</sim-basic-material-dialog>
